import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUIStore } from '../store/uiStore';

export function LanguageToggle() {
  const { t, i18n } = useTranslation();
  const { language, persistLanguage, setLanguage } = useUIStore();
  const [showDropdown, setShowDropdown] = useState(false);

  const languages = [
    { code: 'en', name: t('lang.english') },
    { code: 'af', name: t('lang.afrikaans') },
  ];

  const handleLanguageChange = (newLanguage: string, persist: boolean) => {
    i18n.changeLanguage(newLanguage);
    setLanguage(newLanguage, persist);
    setShowDropdown(false);
  };

  const currentLanguage = languages.find(lang => lang.code === language) || languages[0];

  return (
    <div className="relative">
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="flex items-center space-x-2 px-3 py-2 text-sm rounded-md hover:bg-gray-100 transition-colors"
        aria-label={t('lang.label')}
        aria-expanded={showDropdown}
        aria-haspopup="true"
      >
        <span>🌐</span>
        <span>{currentLanguage.name}</span>
        <span className={`transition-transform ${showDropdown ? 'rotate-180' : ''}`}>
          ▼
        </span>
      </button>

      {showDropdown && (
        <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-10 min-w-[200px]">
          <div className="py-1">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code, persistLanguage)}
                className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition-colors ${
                  language === lang.code ? 'bg-gray-50 font-medium' : ''
                }`}
              >
                {lang.name}
              </button>
            ))}
            <div className="border-t border-gray-200 mt-1 pt-1">
              <label className="flex items-center px-4 py-2 text-sm text-gray-600">
                <input
                  type="checkbox"
                  checked={persistLanguage}
                  onChange={(e) => setLanguage(language, e.target.checked)}
                  className="h-3 w-3 text-primary focus:ring-primary border-gray-300 rounded mr-2"
                />
                {t('lang.persist')}
              </label>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
